import { absolutePath } from "./absolutePath";

export interface AnalyticsApiParams {
  date_grouping: string;
  end_date: string;
  filters?: object;
  start_date: string;
}

export const analytics = {
  paywalls: {
    overview: {
      total_transactions: (params: AnalyticsApiParams) =>
        absolutePath("analytics/paywalls/overview/total_transactions", params),
      total_revenue: (params: AnalyticsApiParams) =>
        absolutePath("analytics/paywalls/overview/total_revenue", params),
    },
  },
};
